export const initialState = () => ({
  state: "",
  pos: "",
  seller: "",
  stateOptions: [],
  posOptions: [],
  sellerOptions: [],
  captationOptions: [],
  caption: {
    name: "",
    uuid: ""
  },
  wallet: ""
})
